import { render, staticRenderFns } from "./BedAvailability.vue?vue&type=template&id=4d9c321a&scoped=true"
import script from "./BedAvailability.vue?vue&type=script&lang=js"
export * from "./BedAvailability.vue?vue&type=script&lang=js"
import style0 from "./BedAvailability.vue?vue&type=style&index=0&id=4d9c321a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c321a",
  null
  
)

export default component.exports